// extracted by mini-css-extract-plugin
module.exports = {"readMoreContent":"ReadMoreSection_readMoreContent__EwWsp","readMoreButton":"ReadMoreSection_readMoreButton__QFo80","expandedContainer":"ReadMoreSection_expandedContainer__UOlaO"};